export const tagColors: string[] = [
  "#5eaf60", // light green
  "green", // green
  "#62bd9c", // turquoise green
  "#53a285", // muted green
  "#add8e6", // pastel sky blue
  "#5293c5", // light blue
  "#3280ba", // blue
  "blue", // pure blue
  "#3d556f", // dark slate blue
  "#dab0d8", // lighter violet
  "#a362bf", // purple
  "#9370db", // medium purple
  "#7b68ee", // medium slate blue
  "#8474a1", // soft purple
  "#e74b3c", // red orange
  "red", // red
  "#bf3b2c", // dark red
  "#f0e68c", // khaki (soft yellow)
  "#20b2aa", // light sea green
  "#000000", // black
];
